import page from "./page";
import root from "./root";

export const wrapPageElement = page;
export const wrapRootElement = root;
